module.exports = __webpack_public_path__ + "img/wengan.65466591.jpg";